const ENV = {
    dev: "https://devpoftigo.azurewebsites.net",
    test: "https://testpoftigo.azurewebsites.net",
    live: "https://api.poftigo.app"
}

export { ENV };